import AsyncStorage from "@react-native-community/async-storage";
import React, { useEffect,useState } from "react";
import { View, StyleSheet, Text, TouchableOpacity } from "react-native";
import { TextInput } from "react-native-gesture-handler";
import { ImageBackground } from "react-native-web";
import api from "../config/api_urls";
import Menu from "../menu";

export default function Joc360(RouterData) {
  var  DATA = RouterData.route.params.current360;
  const [guessArray, setGuessArray] = React.useState(
    new Array(DATA["Resposta"+RouterData.route.params.idioma].length).fill({ letter: "", correct: null })
  );
  const [loaded, setLoaded] = React.useState(false);

  RouterData.navigation.addListener("blur", () => {
    // Close iframe
    setLoaded(false);
  });

  RouterData.navigation.addListener("focus", () => {
    // Open iframe
    setLoaded(true);
  });

  
  function checkLetter(char, position) {
    if (char == "") {
      setGuessArray(
        guessArray.map((letter, index) => {
          if (index == position) {
            return {
              ...letter,
              letter: char.toUpperCase(),
              correct: null,
            };
          } else {
            return letter;
          }
        })
      );
    } else if (char.toLowerCase() == DATA["Resposta"+RouterData.route.params.idioma][position].toLowerCase()) {
      setGuessArray(
        guessArray.map((letter, index) => {
          if (index == position) {
            return {
              ...letter,
              letter: char.toUpperCase(),
              correct: true,
            };
          } else {
            return letter;
          }
        })
      );
    } else {
      setGuessArray(
        guessArray.map((letter, index) => {
          if (index == position) {
            return {
              ...letter,
              letter: char.toUpperCase(),
              correct: false,
            };
          } else {
            return letter;
          }
        })
      );
    }
  }

  function checkWin() {
    if (DATA["Resposta"+RouterData.route.params.idioma].includes(" ")) {
      // Apanyo per fer que els espais siguin correctes
      let index = DATA["Resposta"+RouterData.route.params.idioma].indexOf(" ");
      if (guessArray[index].correct != true) {
        setGuessArray(
          guessArray.map((letter, pos) => {
            if (index == pos) {
              return {
                ...letter,
                letter: " ",
                correct: true,
              };
            } else {
              return letter;
            }
          })
        );
      }
    }
    if (guessArray.every((letter) => letter.correct === true)) {
      console.log("You won");
      
      RouterData.navigation.navigate("Premi360", RouterData.route.params);
    }
  }

  if (loaded) {
    return (
      // <View style={{ flex: 1, }}>
      <ImageBackground source={RouterData.route.params.projecte['FonsPantalla7'] ? { uri: api.api_url + RouterData.route.params.projecte['FonsPantalla7'].url } : null} style={styles.imageBackground}>

        <View
          style={{
            flex: 10,
            alignItems: "center",
            justifyContent: "center",
            color: "#898B8E",
            width: "90%",
            alignSelf: "center",
            paddingBottom: "0.5rem",
            paddingTop: "0.5rem",
          }}
        >
          <Text style={{ fontSize: "5vh", fontFamily: "Brushway",justifyContent:'center',textAlign:'center',paddingTop:'1vh' }}>
            {DATA["Pregunta"+RouterData.route.params.idioma]}
          </Text>
        </View>

        <View
          style={{
            flex: 40,
            borderRadius: 20,
            width: "90%",
            justifyContent: "center",
            alignSelf: "center",
            paddingBottom: "3rem",
          }}
        >
          <iframe
            src={DATA.URL}
            allow="fullscreen;geolocation;camera;gyroscope;accelerometer;magnetometer"
            style={{
              height: "100%",
              width: "100%",
              resizeMode: "contain",
              borderRadius: 16,
            }}
          />
        </View>

        {checkWin()}
        <View style={[styles.guessRow,{flex:20}]}>
          {guessArray.map((letter, index) => {
            return (
              <TextInput
                style={[
                  DATA["Resposta"+RouterData.route.params.idioma][index] == " "
                    ? styles.letterIsSpace
                    : letter.correct
                    ? styles.guessSquareCorrect
                    : letter.correct === false
                    ? styles.guessSquareWrong
                    : styles.guessSquare,
                  DATA["Resposta"+RouterData.route.params.idioma].length >= 8
                    ? { width: "1.5rem", height: "3rem" }
                    : { width: "2.3rem", height: "3.8rem" },
                ]}
                key={index}
                value={guessArray[index].letter}
                editable={DATA["Resposta"+RouterData.route.params.idioma][index] == " " ? false : true}
                onChangeText={(text) => {
                  if (text.length > 1) {
                    text = text[text.length - 1];
                  }
                  checkLetter(text, index);
                }}
              />
            );
          })}
        </View>
        <View
          style={{ flex: 2, bottom: 0, left: 0, right: 0, position: "fixed" }}
        >
          <Menu projecte={RouterData.route.params}></Menu>
        </View>
        </ImageBackground>
      // -</View>
    );
  } else {
    return <View style={{ flex: 1, backgroundColor: "#f5f7fa" }}></View>;
  }
}

const styles = StyleSheet.create({
  guessRow: {
    flex: 40,
    flexDirection: "row",
    justifyContent: "center",
    alignContent: "center",
    alignSelf: "center",
  },
  guessSquare: {
    backgroundColor: "#FAFAFA",
    border: "1px dashed #C4C4C4",
    borderRadius: "4px",
    alignItems: "center",
    justifyContent: "center",
    margin: 5,
    textAlign: "center",
    fontWeight: "bold",
  },

  guessSquareWrong: {
    backgroundColor: "#FDF1D2",
    border: "1px solid #F3BB1C",
    boxShadow: "0px 2px 3px rgba(0, 0, 0, 0.45)",
    borderRadius: "6px",
    margin: 5,
    fontWeight: "bold",
    textAlign: "center",
  },

  letterIsSpace: {
    backgroundColor: "#d3d6da",
    border: "2px dashed #848484",
    boxShadow:
      "0px 2px 5px rgba(0, 0, 0, 0.25), inset -3px -3px 2px rgba(0, 0, 0, 0.25), inset 3px 3px 2px rgba(0, 0, 0, 0.25)",
    borderRadius: "4px",
    margin: 5,
    fontWeight: "bold",
    textAlign: "center",
  },

  guessSquareCorrect: {
    backgroundColor: "#B9EE7F",
    border: "1px solid #66C200",
    boxShadow: "0px 2px 3px rgba(0, 0, 0, 0.45)",
    borderRadius: "6px",
    margin: 5,
    fontWeight: "bold",
    textAlign: "center",
  },
  imageBackground: {
    flex: 1,
    resizeMode: "cover",
    justifyContent: "center",
  },
});
